
import {
addCart,
getCartCount
} from '../../api';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import querystring from 'vux/src/tools/querystring/index.js'

export default {
directives: {
TransferDom
},
components: {
Popup,
},
methods: {
add() {
let num = this.num;
num++;
this.num = num;
},
rem() {
var num = this.num;
num--;
if (num < 1) {
num = 1;
};
this.num = num;
},
hidePopup() {
this.$store.commit('updateShoppPopup', {
isTrue: false
});
},
createOrder() {
this.$store.commit('showIsLoading');
let data = querystring.stringify({
item_id: this.data.item_id,
sku_id: Object.keys(this.data.sku)[0], //商品id
quantity: this.num 
});

if (this.openType == 'group') {
data = data + `&groupbuy_id=${this.data.groupbuy_info.groupbuy_id}`
data = data + `&mode=appfastbuy`;
} else {
data = data + `&mode=${this.openType}`;
};

addCart(data).then(res => {
if (res.data.error_code != 0) {
this.$store.commit('updateToast', {
show: true,
text: res.data.msg
});
this.$store.commit('updateShoppPopup', {
isTrue: false
});
return;
};
if (res.data.dtyList && !Object.keys(res.data.dtyList).length) {
this.$store.commit('updateToast', {
show: true,
text: '商家尚未添加运费模板,请联系商家。'
});
this.$store.commit('updateShoppPopup', {
isTrue: false
});
return;
}


getCartCount();
if (this.openType == 'cart') {
this.$store.commit('updateToast', {
text: res.data.msg,
show: true
});
} else {
if (this.openType == 'group') {
res.data.groupbuy_id = this.data.groupbuy_info.groupbuy_id;
};
this.$router.push({
name: 'createOrder',
params: {
cart: JSON.stringify(res.data),
pathName: 'detail'
}
});
};
this.$store.commit('updateShoppPopup', {
isTrue: false
});

});

return;
this.$router.push({
name: 'createOrder'
})
},
tabYear(index) {
this.yearTabIndex = index;
},
tabCapacity(index) {
this.capacityTabIndex = index;
}
},
mounted() {
var that = this;
var yearArr = Object.keys(this.data.spec_desc[27]);
that.yearTabIndex = yearArr[0];
var capacityArr = Object.keys(this.data.spec_desc[28]);
that.capacityTabIndex = capacityArr[0];
console.log(this.data);
console.log(Object.keys(this.data.sku));

},
computed: {
hideDescribe() {
return this.$store.state.shoppPopup;
},
openType() {
return this.$store.state.shoppOpenType;
}
},
data() {
return {
num: 1,
yearTabIndex: "",
capacityTabIndex: ""
}
},
props: ['data']
};



// WEBPACK FOOTER //
// ./src/components/Detail/ShoppCart.vue